import styled from 'styled-components';
import { colors, spacing, smallShadow } from 'ui/theme';
import { NavTabsList, NavTabTrigger } from 'ui/tabsGroup';

export const StyledAffinityBreakdownCard = styled.div`
  border-radius: ${spacing.half};
  background-color: ${colors.backgroundPrimary};
  ${smallShadow};
  margin-top: ${spacing.plusHalf} !important;
`;

export const StyledNavTabsList = styled(NavTabsList)`
  display: flex;
  justify-content: space-around;
  padding-left: ${spacing.threeQuarter};
  padding-right: ${spacing.threeQuarter};
  width: 100%;
`;

export const StyledNavTabsTrigger = styled(NavTabTrigger)`
  width: 100%;
`;
